import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';

import './callout.scss';

export interface ICallout extends IComponent {}

const classNames = () =>
  makeClassNames({
    callout: 'callout',
  });

/**
 * Returns a `<div />` with passed children
 *
 * @param children - React nodes to include between tags
 * @returns The `<Callout />` component
 */
const Callout = ({ children }: ICallout) => {
  const cn = classNames();

  return <div className={cn.callout}>{children}</div>;
};

export default Callout;
